export default __webpack_public_path__ + "static/media/seo.c74a3d1d.svg";